window.BSS_B2B.addFilter('detect:product_variant', (curVariantId, { productFormId }) => {

  if (window.location.pathname.includes("/products/")) {
    const el = document.querySelector(
      "[bss-b2b-main-product-form] [bss-b2b-variant-id]"
    );

    if (el) {
      curVariantId = Number(el.getAttribute("bss-b2b-variant-id"));
    }
  }
  return curVariantId;
});

if (window.location.pathname.includes("/products/")) {
  const priceEls = document.querySelectorAll("product-price");

  priceEls.forEach(el => {
    el.style.display = "none";

    setTimeout(() => {
      el.style.display = "";
    }, 1000);
  });
}

